import {connect} from "react-redux"
import State from "../../models/State"

export const mapStateToProps = (state: State) => {
    const {
        template,
        search: {itemsRequestPending, breadcrumbs},
        request: {url},
    } = state

    return {
        templating: template,
        itemsRequestPending,
        breadcrumbs,
        url,
    }
}

export default connect(mapStateToProps)
